module.exports = __webpack_public_path__ + "static/media/the-fisherman-selling-his-catch-on-social-media.ecd7a3b2.jpg";